import { SVGProps, Ref, forwardRef } from 'react';

export const FlameOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m8.228 8.735.257-2.57c.026-.264.036-.564.01-.883-.07-.867-.4-1.89-1.428-2.742-.598 1.022-1.324 1.773-1.97 2.442l-.326.337c-.87.91-1.534 1.714-1.77 2.965-.637 3.385 1.92 5.816 4.935 5.816 2.479 0 4.15-1.29 4.824-2.917.598-1.444.442-3.229-.754-4.767a5.436 5.436 0 0 1-1.485 1.133zm3.06-3.642.08-.114.003-.006.465-.771.64.638q.195.195.371.396c1.725 1.98 2.05 4.445 1.207 6.483C13.15 13.9 10.947 15.5 7.936 15.5c-3.739 0-7.138-3.085-6.31-7.475.315-1.674 1.229-2.728 2.134-3.673q.142-.15.286-.298c.682-.706 1.334-1.38 1.85-2.287q.15-.259.28-.545L6.509.5l.68.414q.273.165.513.344C9.05 2.26 9.625 3.516 9.823 4.641a6 6 0 0 1 .067.527c.034.416.022.802-.012 1.137.344-.178.631-.394.863-.606a4.4 4.4 0 0 0 .548-.606"
                fill="currentColor"
            />
        </g>
    </svg>
));
FlameOutlinedSize16Glyph.displayName = 'FlameOutlinedSize16Glyph';
